<div *ngIf="!isMarkerCategoryReady || !isAccountReady">
  <div class="text-center spinner-wrapper">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay">
  <div class="text-center spinner-wrapper">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div class="faceshare-component" [class]="isMarkerCategoryReady && isAccountReady ? '' : 'not-show'">
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="card mb-30">
        <div class="title-header">
          <h2>SOVI</h2>

        </div>
        <div class="title-header" style="margin-bottom: 15px;">
          <span style="color: red;">* Please note that the figures on this page differ from
            those of the SMDD KPI's SOVI
            due to difference in categories. Thank you for your understanding.</span><br />
          <span style="color: red;">* SMDD KPIのSOVIとはカテゴリーの対象が異なる為、数字に違いがあります。ご了承のほどよろしくお願いいたします。</span>
        </div>
        <sales-date-filter pageName="FaceShare"
          (onDateTypeSaveItemsChange)="onDateTypeSaveItemsChange($event)"></sales-date-filter>
      </div>

      <div>
        <faceshare-by-marker-category [lstOptionSelectedDateType]="lstOptionAggregatedDateType"
          [lstOptionSelectedSalesDate]="lstOptionSelectedSalesDate" (ready)="markerCategoryReady($event)"
          (filterReady)="markerCategoryFilterReady($event)"></faceshare-by-marker-category>

        <faceshare-by-account [lstOptionSelectedDateType]="lstOptionAggregatedDateType"
          [lstOptionSelectedSalesDate]="lstOptionSelectedSalesDate" (ready)="accountReady($event)"
          (filterReady)="accountFilterReady($event)"></faceshare-by-account>

        <faceshare-by-sku [lstOptionSelectedSalesDate]="lstOptionSelectedSalesDate"></faceshare-by-sku>

        <faceshare-by-account-by-sku
          [lstOptionSelectedSalesDate]="lstOptionSelectedSalesDate"></faceshare-by-account-by-sku>
      </div>
    </div>
  </div>
</div>